import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import React from "react";
import { twMerge } from "tailwind-merge";

type ReadOnlyFormData = Record<string, string>;

interface ReadOnlyFormProps {
  data: ReadOnlyFormData;
  colsCount: number;
}

const DynamicReadOnlyForm: React.FC<ReadOnlyFormProps> = ({ data, colsCount }) => {
  const theme = useAtomValue(themeAtom);

  const gridClass = `grid grid-cols-${colsCount} gap-4`;

  return (
    <div className={gridClass}>
      {Object.entries(data).length > 0 ? (
        Object.entries(data).map(([label, value], index) => (
          <div key={index} className="py-2">
            <div className={twMerge("text-custom-label text-xs font-normal capitalize", theme.vesselDetails.fields)}>
              {label}:
            </div>
            <div className={twMerge("text-custom-value text-sm font-normal", theme.vesselDetails.info)}>
              {value || "N/A"}
            </div>
          </div>
        ))
      ) : (
        <div className="py-2">
          <div className={twMerge("text-custom-label text-xs font-normal", theme.vesselDetails.fields)}>
            No data available
          </div>
        </div>
      )}
    </div>
  );
};

export default DynamicReadOnlyForm;
